import { css } from '@emotion/react'
import { HFlow, ModalFooter, ModalFooterButton, useTheme } from 'bold-ui'
import { resolveName } from 'components/form'
import { IconLabel } from 'components/IconLabel'
import { useFirebase } from 'hooks/firebase/useFirebase'
import { RefObject } from 'react'
import { useField } from 'react-final-form'
import { MetaRoot } from 'util/metaPath'

import { MChatMarca } from '../../components/MChatMarca'
import { getPerguntaAtivaInfo } from '../consulta-seguimento-aplicacao/utils-consultaSeguimentoAplicacao'
import { ConsultaSeguimentoModalTab } from '../enums-consultaSeguimento'
import { ConsultaSeguimentoFieldModel } from '../model-consultaSeguimento'
import { ConsultaSeguimentoModalFooterCounter } from './ConsultaSeguimentoModalFooterCounter'

interface ConsultaSeguimentoModalFooterProps {
  name: MetaRoot<ConsultaSeguimentoFieldModel>
  goNextButtonRef: RefObject<HTMLButtonElement>
  currentTab: ConsultaSeguimentoModalTab
  isMChatRiscoBaixo: boolean
  startFailed: boolean
  onStart: () => void
  onGoToNextQuestion: () => void
  onCloseModal: () => void
}

export function ConsultaSeguimentoModalFooter(props: Readonly<ConsultaSeguimentoModalFooterProps>) {
  const {
    name,
    goNextButtonRef,
    currentTab,
    isMChatRiscoBaixo,
    startFailed,
    onStart,
    onGoToNextQuestion,
    onCloseModal,
  } = props

  const theme = useTheme()
  const { analytics } = useFirebase()

  const {
    input: { value: aplicacao },
    meta: { error = {} },
  } = useField(resolveName(name.aplicacao), { subscription: { value: true, error: true } })

  const { perguntaAtiva, isLast: isLastPergunta } = getPerguntaAtivaInfo(aplicacao)
  const isInvalid = (perguntaAtiva && perguntaAtiva in error) ?? false

  const handleGoToNextQuestion = () => {
    if (isLastPergunta) {
      analytics.logEvent('click_calcular_mchatrf')
    }
    onGoToNextQuestion()
  }

  const handleStart = () => {
    analytics.logEvent('click_iniciar_mchatrf')
    onStart()
  }

  return (
    <ModalFooter>
      <HFlow alignItems='center' justifyContent='space-between'>
        <MChatMarca style={styles.authorsLabel} />

        <HFlow justifyContent='flex-end' alignItems='center'>
          {currentTab === ConsultaSeguimentoModalTab.RESULTADO && (
            <IconLabel
              icon='checkCircleOutline'
              text='Resultado salvo no atendimento'
              color={theme.pallete.status.success.c40}
            />
          )}

          {currentTab === ConsultaSeguimentoModalTab.SELECAO && (
            <ConsultaSeguimentoModalFooterCounter
              name={name.perguntasSelecionadas}
              isMChatRiscoBaixo={isMChatRiscoBaixo}
              startFailed={startFailed}
            />
          )}

          <ModalFooterButton onClick={onCloseModal}>
            {currentTab === ConsultaSeguimentoModalTab.RESULTADO ? 'Fechar' : 'Cancelar'}
          </ModalFooterButton>

          {currentTab === ConsultaSeguimentoModalTab.SELECAO && (
            <ModalFooterButton kind='primary' onClick={handleStart}>
              Iniciar
            </ModalFooterButton>
          )}

          {currentTab === ConsultaSeguimentoModalTab.APLICACAO && (
            <ModalFooterButton
              kind='primary'
              innerRef={goNextButtonRef}
              onClick={handleGoToNextQuestion}
              disabled={isInvalid}
            >
              {isLastPergunta ? 'Calcular resultado' : 'Continuar'}
            </ModalFooterButton>
          )}
        </HFlow>
      </HFlow>
    </ModalFooter>
  )
}

const styles = {
  authorsLabel: css`
    padding-left: 1rem;
  `,
}
